angular.module('TetherApp').factory('templateService', [function () {

    /**
     * Base directory for control template files
     * @type {string}
     */
    let fieldBaseUrl = '/html/';

    /**
     * File names for control templates
     * @type {{label: string, text: string, radio: string, checkbox: string, datepicker: string, textarea: string, select: string, submit: string, button: string, image: string, file: string, passingScore: string}}
     */
    let templateInfo = {
        label: 'form/tetherLabel.html',
        text: 'form/tetherText.html',
        radio: 'form/tetherRadio.html',
        checkbox: 'form/tetherCheckbox.html',
        datepicker: 'form/tetherDatepicker.html',
        textarea: 'form/tetherTextarea.html',
        select: 'form/tetherSelect.html',
        submit: 'form/tetherSubmit.html',
        button: 'form/tetherButton.html',
        image: 'form/tetherImage.html',
        file: 'form/tetherFile.html',
        passingScore: 'experience/survey/surveyPassingScore.html',
        formCreator: 'experience/survey/surveyFormCreator.html',
        surveySelectProperties: 'experience/survey/form/surveySelectProperties.html',
        surveyRadioProperties: 'experience/survey/form/surveyRadioProperties.html',
        surveyControlProperties: 'experience/survey/form/surveyControlProperties.html',
        sweepstakesStartedAt: 'experience/sweepstakes/sweepstakesDatepickerStartedAt.html',
        sweepstakesEndedAt: 'experience/sweepstakes/sweepstakesDatepickerEndedAt.html',
        sweepstakesText: 'experience/sweepstakes/form/sweepstakesText.html',
        sweepstakesSelect: 'experience/sweepstakes/form/sweepstakesSelect.html',
        sweepstakesTextarea: 'experience/sweepstakes/form/sweepstakesTextarea.html',
        sweepstakesPrizePoolName: 'experience/sweepstakes/form/sweepstakesPrizePoolName.html'
    };

    /**
     * Get the url for the requested type of control
     * @param type i.e. button, select, radio
     * @param subDirectory i.e. form, experience/form
     * @returns {string}
     */
    let getTemplateUrl = function (type, subDirectory) {
        let url = '';
        if (subDirectory !== undefined){
            url = fieldBaseUrl + subDirectory + '/' + templateInfo[type];
        } else {
            url = fieldBaseUrl + templateInfo[type];
        }
        return url;
    };

    return {
        getTemplateUrl: getTemplateUrl
    };

}]);
